import * as React from 'react';

function SvgPadlockStroke2(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.41 11.554l.001-2.699v-.002A4.282 4.282 0 0015.044 4.7c-2.345-.039-4.284 1.82-4.344 4.146v2.765A7.664 7.664 0 0115 10.3c1.64 0 3.162.513 4.41 1.388v-.134zm1.4 1.394V8.832a5.68 5.68 0 00-5.766-5.531C11.954 3.25 9.38 5.716 9.3 8.829v3.925c0 .022 0 .044.003.066a7.7 7.7 0 1011.508.128zm-3.615 3.858v-.012a2.434 2.434 0 00-3.968-1.85 1.301 1.301 0 00-.327.337c-.807 1.02-.631 2.547.416 3.385.012.01.028.045.028.08v1.618c0 .73.592 1.323 1.322 1.323h.26c.73 0 1.322-.592 1.322-1.323v-1.617a.12.12 0 01.046-.09c.563-.441.898-1.125.9-1.85zm-3.252-.9c.406-.328.91-.39 1.339-.19.426.198.702.622.713 1.092a1.17 1.17 0 01-.45.91c-.314.256-.494.63-.496 1.025v1.621a.122.122 0 01-.123.123h-.26a.122.122 0 01-.122-.123v-1.617c0-.387-.169-.754-.463-1.005a1.247 1.247 0 01-.215-1.751.31.31 0 01.077-.086zM15 24.3a6.3 6.3 0 100-12.6 6.3 6.3 0 000 12.6z"
        fill="#414B56"
      />
    </svg>
  );
}

export default SvgPadlockStroke2;
